import {
  IonContent,
  IonPage,
  IonRow,
  IonCol,
  IonLabel,
} from "@ionic/react";
import React from "react";
import { HelpoHeader } from "../components/shared/HelpoHeader";
import { ThemeCard } from "../components/themes/ThemeCard";

export const Explore: React.FC = () => {
  return (
    <IonPage>
      <HelpoHeader title="Explore" />
      <IonContent>
        {/* <IonRow class="ion-justify-content-center">
          <IonCol size="12" sizeMd="9" sizeLg="6">
            <IonSearchbar />
          </IonCol>
        </IonRow> */}
        <IonRow class="ion-justify-content-center ion-padding-top">
          <IonCol size="12" sizeMd="9" sizeLg="6">
            <IonLabel class="ion-text-uppercase ion-padding" color="medium">
              Themes
            </IonLabel>
            <ThemeCard
              title="Wellness"
              imgSrc="https://picsum.photos/320/120"
            />
            <ThemeCard
              title="Community"
              imgSrc="https://picsum.photos/320/120"
            />
            <ThemeCard
              title="Learn"
              imgSrc="https://picsum.photos/320/120"
            />
            <ThemeCard
              title="Social"
              imgSrc="https://picsum.photos/320/120"
            />
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};
